export enum ParkingSecurity {
  SELECT_SECURITY= 'Select Security',
  NOT_GARAGED= 'Not garaged',
  CARPORT_SECURED= 'Carport secured',
  CARPORT_UNSECURED= 'Carport unsecured',
  DRIVEWAY= 'Driveway',
  ENCLOSURE_LOCKED = 'Enclosure locked',
  GARAGE_SECURED= 'Garage secured',
  GARAGE_UNSECURED=  'Garage Unsecured',
  GARAGE_UNSPECIFIED = ' Garage unspecified / other',
  STREET = 'Street'
}
